export * from 'server/models/Rate';


// WEBPACK FOOTER //
// ./data/models/Rate.ts